// test104
(104 && 0);
